import styled from 'styled-components';
import Parent from '../Base/style';

const UploadWrapper = styled(Parent)`
.filepond--wrapper {
    border: 2px solid transparent!important;
}
`;
export default UploadWrapper;
